module.exports = __webpack_public_path__ + "static/img/Frame 2509@2x.9c647a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Frame 2509@2x.png
// module id = Ylm1
// module chunks = 1